import { GetEmailLogByEmailId, GetEmailLogList } from "../ApiEndPoints";
import { axiosGetAuthorize, axiosPostAuthorize } from "../AxiosRequests";

export default class EmailLogsServices {

    //** Call API : */
    async getEmailLogList(request) {
        return axiosPostAuthorize(GetEmailLogList, request);
    }
     async getEmailLogByEmailId(request) {
            return axiosGetAuthorize(GetEmailLogByEmailId, request);
        }
}
